/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelMenuOrders } from './FuelMenuOrders';
import {
    FuelMenuOrdersFromJSON,
    FuelMenuOrdersFromJSONTyped,
    FuelMenuOrdersToJSON,
    FuelMenuOrdersToJSONTyped,
} from './FuelMenuOrders';

/**
 * 
 * @export
 * @interface GetMenuOrdersFuelDataResponse
 */
export interface GetMenuOrdersFuelDataResponse {
    /**
     * 
     * @type {Array<FuelMenuOrders>}
     * @memberof GetMenuOrdersFuelDataResponse
     */
    menuOrders: Array<FuelMenuOrders>;
}

/**
 * Check if a given object implements the GetMenuOrdersFuelDataResponse interface.
 */
export function instanceOfGetMenuOrdersFuelDataResponse(value: object): value is GetMenuOrdersFuelDataResponse {
    if (!('menuOrders' in value) || value['menuOrders'] === undefined) return false;
    return true;
}

export function GetMenuOrdersFuelDataResponseFromJSON(json: any): GetMenuOrdersFuelDataResponse {
    return GetMenuOrdersFuelDataResponseFromJSONTyped(json, false);
}

export function GetMenuOrdersFuelDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuOrdersFuelDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'menuOrders': ((json['menuOrders'] as Array<any>).map(FuelMenuOrdersFromJSON)),
    };
}

export function GetMenuOrdersFuelDataResponseToJSON(json: any): GetMenuOrdersFuelDataResponse {
    return GetMenuOrdersFuelDataResponseToJSONTyped(json, false);
}

export function GetMenuOrdersFuelDataResponseToJSONTyped(value?: GetMenuOrdersFuelDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'menuOrders': ((value['menuOrders'] as Array<any>).map(FuelMenuOrdersToJSON)),
    };
}

